import { departmentListQuery, departmentsForStudentQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';
import startCase from 'lodash/startCase';

export const getDepartmentsForSelect = (
  departments:
    | (departmentsForStudentQuery['departmentsForStudent'][0] | departmentListQuery['department'][0])[]
    | undefined,
): HSMSSelectOption[] => {
  if (departments) {
    const departmentsForSelect = departments.map(
      (department: departmentsForStudentQuery['departmentsForStudent'][0] | departmentListQuery['department'][0]) => {
        return {
          value: department.id,
          label: startCase(department.name),
        };
      },
    );

    return departmentsForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
